import { getCard } from "../../content/lookups.js";
import { canPlayCard } from "../../domain/selectors/canPlayCard.js";
import type { RunState } from "../../domain/types/index.js";

/** 手札に、いま直ちに使える施策カードがあるかを返す。 */
export function hasPlayableAction(run: RunState): boolean {
  return run.hand.some((card) => {
    const definition = getCard(card.cardId);
    return definition ? canPlayCard(run, definition) : false;
  });
}
